<mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
    <mat-expansion-panel-header class="disable_ripple">
        <mat-panel-title>
            <!-- <b [ngStyle]="{color: this.frmLearningPlan.errors?.['required'] ? 'red': ''}">LEARNING PLAN </b> -->

            <div *ngIf="this.frmLearningPlan.errors?.['required']==null">
                <b>LEARNING PLAN </b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_LearningPlan_Overview'"></help-text-btn>
            </div>
            <div *ngIf="this.frmLearningPlan.errors?.['required']">
                <b style="color: red;">LEARNING PLAN (incomplete)</b>
            </div>

        </mat-panel-title>

    </mat-expansion-panel-header>

    <form [formGroup]="frmLearningPlan">
        <div class="row">            
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6" style="padding-top: 10px;">
                <div class="row">
                    <div class="col">
                        <mat-label>
                            <b [ngStyle]="{color: this.frmLearningPlan.errors?.['required'] ? 'red': ''}">
                                Recommended Instructional Services *
                            </b>
							<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_LearningPlan_RecommendedInstructionalServices'"></help-text-btn>
                        </mat-label>
                    </div>
                </div>
                <div class="row" style="padding-top: 10px;">
                    <div *ngIf="this.action!=3" class="col">
                        <app-table-edit-service [lookupService]="lookupInstructionalService"
                            [(serviceData)]="lstInstructionalService" (panelOpenState)="pOpenStateIS($event)">
                        </app-table-edit-service>
                    </div>
                </div>
                <div class="row" style="padding-top: 10px;">
                    <div *ngIf="this.boolPnlOpenStateIS == false && this.lstInstructionalService.length > 0"
                        class="col">
                        <mat-chip-listbox #chipList>
                            <div class="chipWrap">
                            <mat-chip-option *ngFor="let serviceEvent of lstInstructionalService"
                                (removed)="removeIS(serviceEvent)">
                                <div class="chipWrap">
                                    {{serviceEvent.SERVICE_CODE}} - {{ serviceEvent.SERVICE_NAME }}
                                </div>
                                <button *ngIf="this.action!=3" matChipRemove><mat-icon>cancel</mat-icon></button>
                            </mat-chip-option>
                        </div>
                        </mat-chip-listbox>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6" style="padding-top: 10px;">
                <div class="row">
                    <div class="col">
                        <mat-label>
                            <b [ngStyle]="{color: this.frmLearningPlan.errors?.['required'] ? 'red': ''}">
                                Recommended Support Services *
                            </b>
							<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_LearningPlan_RecommendedSupportServices'"></help-text-btn>
                        </mat-label>
                    </div>
                </div>
                <div class="row" style="padding-top: 10px;">
                    <div *ngIf="this.action!=3" class="col">
                        <app-table-edit-service [lookupService]="lookupSupportService"
                            [(serviceData)]="lstSupportService" (panelOpenState)="pOpenStateSS($event)">
                        </app-table-edit-service>
                    </div>
                </div>
                <div class="row" style="padding-top: 10px;">
                    <div *ngIf="this.boolPnlOpenStateSS == false && this.lstSupportService.length > 0" class="col">
                        <mat-chip-listbox #chipList>
                            <mat-chip-option *ngFor="let serviceEvent of lstSupportService"
                                (removed)="removeSS(serviceEvent)">
                                {{serviceEvent.SERVICE_CODE}} - {{ serviceEvent.SERVICE_NAME }}
                                <button *ngIf="this.action!=3" matChipRemove><mat-icon>cancel</mat-icon></button>
                            </mat-chip-option>
                        </mat-chip-listbox>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="padding-top: 30px">
        </div>
        <mat-divider></mat-divider>

        <div class="row" >
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6" style="padding-top: 30px">
                <mat-card>
                    <div class="row" style="padding-top: 10px;padding-bottom: 10px">
                        <div class="col" style="padding-left:30px">
                            <mat-label><b>Non-MEP Services</b>
								<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_LearningPlan_NonMEPServices'"></help-text-btn>
                            </mat-label>
                        </div>
                        <div class="col" *ngIf="editing && this.action!=3">
                            <button mat-raised-button color="primary" class="button-add-row"
                                (click)="addRow('Non MEP Services')">
                                Add Non-MEP Services
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <app-table-edit-comment [(listQuestion)]="nonMEPEditableQuestions" [editing]="editing"
                            (modificationEvent)="OperationCUD($event)" [type]="'Non MEP Services'"
                            [action]="this.action">
                        </app-table-edit-comment>
                    </div>
                </mat-card>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6" style="padding-top: 30px">
                <mat-card>
                    <div class="row" style="padding-top: 10px;padding-bottom: 10px">
                        <div class="col" style="padding-left:30px">
                            <mat-label><b>Goals</b>
								<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_LearningPlan_Goals'"></help-text-btn>
                            </mat-label>
                        </div>
                        <div class="col" *ngIf="editing && this.action!=3">
                            <button mat-raised-button color="primary" class="button-add-row" (click)="addRow('Goals')">
                                Add Goals
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <app-table-edit-comment [(listQuestion)]="goalEditableQuestions" [editing]="editing"
                            (modificationEvent)="OperationCUD($event)" [type]="'Goals'" [action]="this.action">
                        </app-table-edit-comment>
                    </div>
                </mat-card>
            </div>
        </div>
    </form>


    <div class="row" style="padding-top: 30px" *ngIf="(action==2 || action==3) ">
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Past Edit - {{this.trackHistories.inaHistory.length}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="this.trackHistories.inaHistory.length>=1">
                    <app-past-edit [section]="this.section"></app-past-edit>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</mat-expansion-panel>